exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-content-tsx": () => import("./../../../src/templates/content.tsx" /* webpackChunkName: "component---src-templates-content-tsx" */),
  "component---src-templates-menu-tsx": () => import("./../../../src/templates/menu.tsx" /* webpackChunkName: "component---src-templates-menu-tsx" */)
}

